import userPreferences from '../modules/UserPreferences/reducer';
import auth from './auth';
import userCompanies from './user-companies';

const reducer = {
  userCompanies,
  auth,
  userPreferences,
};

export default reducer;
